import { createActionConst } from '../../../../utils/action.utils';

const MEETING_TEMPLATE_NAMESPACE = 'MEETING_TEMPLATE';

export const FETCH_MEETING_TEMPLATES = createActionConst(MEETING_TEMPLATE_NAMESPACE, 'FETCH_MEETING_TEMPLATES');

export const STORE_MEETING_TEMPLATES_IDS = createActionConst(MEETING_TEMPLATE_NAMESPACE, 'STORE_MEETING_TEMPLATES_IDS');
export const CLEAR_MEETING_TEMPLATES_IDS = createActionConst(MEETING_TEMPLATE_NAMESPACE, 'CLEAR_MEETING_TEMPLATES_IDS');
